
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93pkNySb1AZVbv1jS6ZZ_DlvL1DFXxq0H8UhArY9XG_45FQMeta } from "/codebuild/output/src2115314467/src/ark/pages/[...slug].vue?macro=true";
import { default as guias_wYzV9Ru5J56gxbJQBp0QdtY_45W5ClfoFagA3Ie92AgUMeta } from "/codebuild/output/src2115314467/src/ark/pages/blog/guias.vue?macro=true";
import { default as indexAzCRFzltniOo88sBlWe9aqekBKYmssG7eeXSCLNlF6MMeta } from "/codebuild/output/src2115314467/src/ark/pages/blog/index.vue?macro=true";
import { default as temas4NPBU5zkidvDckI8DNdtTFdMDT6i1K_hR_45oBvC09fLAMeta } from "/codebuild/output/src2115314467/src/ark/pages/blog/temas.vue?macro=true";
import { default as pesquisapJDnhryjmUZVEghLzi9aTDhpNnaPPmrkWy7zEvKR6GEMeta } from "/codebuild/output/src2115314467/src/ark/pages/blog/pesquisa.vue?macro=true";
import { default as moradajajy_yfqOPWqV_45t2VIosir21Bruh0K3viMcLHI_fgz4Meta } from "/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue?macro=true";
import { default as habitantesLgjDbc_454GOGSnQyFtqmicU2LIsrglKPI4IAojyi7di8Meta } from "/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue?macro=true";
import { default as escalao_45gasQXOV43fV1wfYdVFh_IiVHw57SH2fHAgKS9lwiSceo_cMeta } from "/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue?macro=true";
import { default as tempo_45em_45casa7c3hY2x8jqrFSRd7JnLwiDHnAGrEcf_45Zz1dJi8XDhF0Meta } from "/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue?macro=true";
import { default as tipo_45de_45produtor_WYWXD1lT21IY3GNQDGeZhMJbfFfKnqK9F_qVFVbQ0Meta } from "/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue?macro=true";
import { default as comercializadoraAtGtAinTc0c4n_45kLhY89nvtGI6m5lB8eTolIRZtTIfIMeta } from "/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue?macro=true";
import { default as dados_45de_45contactoh3VUIzX0jsi0dU0he6GjwC792ToZ9aeEOLtPqiMMmLMMeta } from "/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue?macro=true";
import { default as potencia_45contratadaGq7hSScGo_m5xUALhl_45ix0piS5zy4K0cQA4w6tG0IA4Meta } from "/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue?macro=true";
import { default as simularAPOLWFALrRISa2Z67gexlupCNQcMpZs2pnczaiUTP8cMeta } from "/codebuild/output/src2115314467/src/ark/pages/energia/simular.vue?macro=true";
import { default as internetOD2kPzYu7xjLLEKf8Zp_x8PPrHg36FCydAEqLWs2QecMeta } from "/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue?macro=true";
import { default as telemovelCgPLiKXQA8j72Nz1qByx4OO7u3FN6tkVB46g8hVFwEAMeta } from "/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue?macro=true";
import { default as fidelizacaoRSbwOGdgneQOPtfqTdOg5Ukr3tfnIQPUWnYqTd2ap_IMeta } from "/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue?macro=true";
import { default as operadora_45atuallbQloNqvank0vzUVTakZDnYsjEfyZhLpoDpUi6iKs_4Meta } from "/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue?macro=true";
import { default as dados_45de_45contacto2EtJO_FsnJtGYVD0QS0gsY8FN_45GyDJPQAsqfbIbQ99gMeta } from "/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue?macro=true";
import { default as simularQ1gZrRZPsKB47YOUSF7UkK_iOTNC_45ceTAexI3PFGrmkMeta } from "/codebuild/output/src2115314467/src/ark/pages/tv-net-voz/simular.vue?macro=true";
import { default as _91_46_46_46slug_93Ie95a9N7dQHz4JJpLctSNf06Sjx_45oC4DlHjVoOoyfFAMeta } from "/codebuild/output/src2115314467/src/ark/pages/blog/autor/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93dJDA8VEhVWfMWTuSeU7cYhmabHG7wHu8pFjXohZy0BcMeta } from "/codebuild/output/src2115314467/src/ark/pages/blog/rubricas/[...slug].vue?macro=true";
import { default as resumo8Jo7lk3RcNCTwMzbhzkZ7uY2guWK_45M16N4XPlG2z6yYMeta } from "/codebuild/output/src2115314467/src/ark/pages/depositos-a-prazo/resumo.vue?macro=true";
import { default as finalidadeZQfNsw_ZcxkBKxQ3nIAQEBadda_45TLHOecah_m498Q14Meta } from "/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue?macro=true";
import { default as tipo_45de_45taxabSEH8pXhrcBlXpunXZF7CkP7L0eagZuno4am1oJOr_IMeta } from "/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue?macro=true";
import { default as dados_45de_45contactopIXHevgyzuCBNI_7xqFHXh6u_45_45c4d2Ia442r3cejYD0Meta } from "/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue?macro=true";
import { default as estado_45do_45processoTZJAQTj9xJVzcrpPLkQn3qU_45yrgIcQls4rCNUUNI9BkMeta } from "/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue?macro=true";
import { default as situacao_45financeiragsUXKONv_Vp1gJO9yXwL6yJBSUcJknQT7vRxNRizmmoMeta } from "/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue?macro=true";
import { default as montante_45do_45emprestimoIqo5PfeGZ9JPR8YlC79CWl1UxySBCKeC1XoO4uAmxl0Meta } from "/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue?macro=true";
import { default as simular62LxgZEEDZoahZLLvLDoCBjekHbv0cLtX07BBWjZz0QMeta } from "/codebuild/output/src2115314467/src/ark/pages/credito-habitacao/simular.vue?macro=true";
import { default as _91_46_46_46slug_93zYir0c_JxK3urzINMChNW_SqpI6JdzQGWsmgRoP3gFQMeta } from "/codebuild/output/src2115314467/src/ark/pages/simuladores/embed/[...slug].vue?macro=true";
import { default as resultadosPIcdOLfgAzn8_N6hyj6l0dSGtyZbVHlSEdCAqGtbYzoMeta } from "/codebuild/output/src2115314467/src/ark/pages/credito-habitacao/resultados.vue?macro=true";
import { default as index6J0bhyRhsvB1EMvuGoxs0AMzcSocg7dVpjXHga2NHIEMeta } from "/codebuild/output/src2115314467/src/ark/pages/parcerias-imobiliarias/index.vue?macro=true";
import { default as _91_46_46_46slug_93Yp3xepwdLoXvLSYQLfSZj_P5NbZIzeIFs4ZaDRj2mi0Meta } from "/codebuild/output/src2115314467/src/ark/pages/tv-net-voz/campanhas/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93ct1qRoP2DOxhC0G1GpOXEKIn7oU4p8lIgXLhMNUMNu0Meta } from "/codebuild/output/src2115314467/src/ark/pages/parcerias-imobiliarias/[...slug].vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src2115314467/src/ark/pages/[...slug].vue")
  },
  {
    name: "blog-guias",
    path: "/blog/guias",
    component: () => import("/codebuild/output/src2115314467/src/ark/pages/blog/guias.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/codebuild/output/src2115314467/src/ark/pages/blog/index.vue")
  },
  {
    name: "blog-temas",
    path: "/blog/temas",
    component: () => import("/codebuild/output/src2115314467/src/ark/pages/blog/temas.vue")
  },
  {
    name: "blog-pesquisa",
    path: "/blog/pesquisa",
    component: () => import("/codebuild/output/src2115314467/src/ark/pages/blog/pesquisa.vue")
  },
  {
    name: "energia-simular",
    path: "/energia/simular",
    meta: { ...(simularAPOLWFALrRISa2Z67gexlupCNQcMpZs2pnczaiUTP8cMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src2115314467/src/ark/pages/energia/simular.vue"),
    children: [
  {
    name: "energia-simular-morada",
    path: "morada",
    component: () => import("/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/morada.vue")
  },
  {
    name: "energia-simular-habitantes",
    path: "habitantes",
    component: () => import("/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/habitantes.vue")
  },
  {
    name: "energia-simular-escalao-gas",
    path: "escalao-gas",
    component: () => import("/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/escalao-gas.vue")
  },
  {
    name: "energia-simular-tempo-em-casa",
    path: "tempo-em-casa",
    component: () => import("/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tempo-em-casa.vue")
  },
  {
    name: "energia-simular-tipo-de-produto",
    path: "tipo-de-produto",
    component: () => import("/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/tipo-de-produto.vue")
  },
  {
    name: "energia-simular-comercializadora",
    path: "comercializadora",
    component: () => import("/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/comercializadora.vue")
  },
  {
    name: "energia-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/dados-de-contacto.vue")
  },
  {
    name: "energia-simular-potencia-contratada",
    path: "potencia-contratada",
    component: () => import("/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_en_JEIltKnjEc/pages/energia/simular/potencia-contratada.vue")
  }
]
  },
  {
    name: "tv-net-voz-simular",
    path: "/tv-net-voz/simular",
    meta: { ...(simularQ1gZrRZPsKB47YOUSF7UkK_iOTNC_45ceTAexI3PFGrmkMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src2115314467/src/ark/pages/tv-net-voz/simular.vue"),
    children: [
  {
    name: "tv-net-voz-simular-internet",
    path: "internet",
    component: () => import("/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/internet.vue")
  },
  {
    name: "tv-net-voz-simular-telemovel",
    path: "telemovel",
    component: () => import("/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/telemovel.vue")
  },
  {
    name: "tv-net-voz-simular-fidelizacao",
    path: "fidelizacao",
    component: () => import("/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/fidelizacao.vue")
  },
  {
    name: "tv-net-voz-simular-operadora-atual",
    path: "operadora-atual",
    component: () => import("/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/operadora-atual.vue")
  },
  {
    name: "tv-net-voz-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_bb_ZalWnWA0aY/pages/tv-net-voz/simular/dados-de-contacto.vue")
  }
]
  },
  {
    name: "blog-autor-slug",
    path: "/blog/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src2115314467/src/ark/pages/blog/autor/[...slug].vue")
  },
  {
    name: "blog-rubricas-slug",
    path: "/blog/rubricas/:slug(.*)*",
    component: () => import("/codebuild/output/src2115314467/src/ark/pages/blog/rubricas/[...slug].vue")
  },
  {
    name: "depositos-a-prazo-resumo",
    path: "/depositos-a-prazo/resumo",
    component: () => import("/codebuild/output/src2115314467/src/ark/pages/depositos-a-prazo/resumo.vue")
  },
  {
    name: "credito-habitacao-simular",
    path: "/credito-habitacao/simular",
    meta: { ...(simular62LxgZEEDZoahZLLvLDoCBjekHbv0cLtX07BBWjZz0QMeta || {}), ...{"middleware":["funnel"]} },
    component: () => import("/codebuild/output/src2115314467/src/ark/pages/credito-habitacao/simular.vue"),
    children: [
  {
    name: "credito-habitacao-simular-finalidade",
    path: "finalidade",
    component: () => import("/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/finalidade.vue")
  },
  {
    name: "credito-habitacao-simular-tipo-de-taxa",
    path: "tipo-de-taxa",
    component: () => import("/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/tipo-de-taxa.vue")
  },
  {
    name: "credito-habitacao-simular-dados-de-contacto",
    path: "dados-de-contacto",
    component: () => import("/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/dados-de-contacto.vue")
  },
  {
    name: "credito-habitacao-simular-estado-do-processo",
    path: "estado-do-processo",
    component: () => import("/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/estado-do-processo.vue")
  },
  {
    name: "credito-habitacao-simular-situacao-financeira",
    path: "situacao-financeira",
    component: () => import("/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/situacao-financeira.vue")
  },
  {
    name: "credito-habitacao-simular-montante-do-emprestimo",
    path: "montante-do-emprestimo",
    component: () => import("/codebuild/output/src2115314467/src/ark/node_modules/.c12/github_comparaja_hl_z9xSoGLUJ/pages/credito-habitacao/simular/montante-do-emprestimo.vue")
  }
]
  },
  {
    name: "simuladores-embed-slug",
    path: "/simuladores/embed/:slug(.*)*",
    meta: _91_46_46_46slug_93zYir0c_JxK3urzINMChNW_SqpI6JdzQGWsmgRoP3gFQMeta || {},
    component: () => import("/codebuild/output/src2115314467/src/ark/pages/simuladores/embed/[...slug].vue")
  },
  {
    name: "credito-habitacao-resultados",
    path: "/credito-habitacao/resultados",
    meta: resultadosPIcdOLfgAzn8_N6hyj6l0dSGtyZbVHlSEdCAqGtbYzoMeta || {},
    component: () => import("/codebuild/output/src2115314467/src/ark/pages/credito-habitacao/resultados.vue")
  },
  {
    name: "parcerias-imobiliarias",
    path: "/parcerias-imobiliarias",
    component: () => import("/codebuild/output/src2115314467/src/ark/pages/parcerias-imobiliarias/index.vue")
  },
  {
    name: "tv-net-voz-campanhas-slug",
    path: "/tv-net-voz/campanhas/:slug(.*)*",
    meta: _91_46_46_46slug_93Yp3xepwdLoXvLSYQLfSZj_P5NbZIzeIFs4ZaDRj2mi0Meta || {},
    component: () => import("/codebuild/output/src2115314467/src/ark/pages/tv-net-voz/campanhas/[...slug].vue")
  },
  {
    name: "parcerias-imobiliarias-slug",
    path: "/parcerias-imobiliarias/:slug(.*)*",
    meta: _91_46_46_46slug_93ct1qRoP2DOxhC0G1GpOXEKIn7oU4p8lIgXLhMNUMNu0Meta || {},
    component: () => import("/codebuild/output/src2115314467/src/ark/pages/parcerias-imobiliarias/[...slug].vue")
  }
]